import React, { useState } from "react"
import {
  Card,
  CardBody,
  CardGroup,
  CardText,
  CardTitle,
  Col,
  Row,
  Tooltip,
} from "reactstrap"
import { Field, formValueSelector, resetSection } from "redux-form"
import { TextField } from "components/RenderInput"
import { connect } from "react-redux"
import { addAccessCode } from "store/actions"
import { SaveButton } from "components/Buttons"
import { copyButtonHandler } from "../utils"
import { FORM_NAMES } from "constants/index"

const AddUsersByAccessCode = ({
  vendorId,
  resetSection,
  selectedEvent,
  accessCodeField,
  addAccessCode,
  userId,
  accessCodes,
}) => {
  const [tooltipOpen, setTooltipOpen] = useState(false)

  const generateCodeHandler = () => {
    if (!accessCodeField) {
      return
    }
    addAccessCode(
      { type: 0, user_id: userId, vendor_id: vendorId, word: accessCodeField },
      selectedEvent.id
    )
    resetSection(FORM_NAMES.EXPERIENCE, "permissions.accessCode")
  }

  const toggle = () => setTooltipOpen(!tooltipOpen)

  const downloadCodeHandler = (url, name) => {
    fetch(url).then(response => {
      response.blob().then(imageBlob => {
        saveAs(URL.createObjectURL(imageBlob), `qr_${name}.png`)
      })
    })
  }

  return (
    <Row className="mt-2">
      <Col xs={12}>
        <h5>
          Add Users by Access Code -&nbsp;
          <span style={{ fontWeight: "normal" }}>
            Make this experience visible to users by generating an access code
            to input
          </span>
        </h5>
      </Col>

      <Row className="mx-3 my-3">
        <Col xs={12} md={3} xl={2} className="my-1">
          Personalize Code: &nbsp;
          <span>
            <i className="fas fa-question-circle" id="AutoHideExample"></i>
          </span>
          <Tooltip
            placement="top"
            isOpen={tooltipOpen}
            target="AutoHideExample"
            toggle={toggle}
          >
            Choose a word that you want to be included in the generated code.
            Ex. Johnsbirthday.
          </Tooltip>
        </Col>
        <Col xs={6} md={6} lg={5} xl={3}>
          <Field name="accessCode" component={TextField} />
        </Col>
        <Col xs={6} md={3} lg={3}>
          <SaveButton
            type="button"
            onClick={generateCodeHandler}
            content="Generate Code"
          />
        </Col>
      </Row>
      {accessCodes && (
        <Row className="d-flex justify-content-center">
          {accessCodes.map(accessCode => (
            <Col xl={3} className="my-2" key={accessCode.id}>
              <CardGroup>
                <Card
                  body
                  className="text-center"
                  style={{ border: "1px solid black", padding: "0px" }}
                >
                  <CardBody>
                    <CardTitle>Text Code:</CardTitle>
                    <CardText>{accessCode?.word}</CardText>
                    <i
                      className="bx bx-sm bx-copy mt-2"
                      style={{
                        cursor: "pointer",
                        padding: "3px",
                        border: "1px solid lightGray",
                      }}
                      title="Copy code"
                      onClick={() => copyButtonHandler(accessCode?.word)}
                    />
                  </CardBody>
                </Card>
                <Card
                  body
                  className="text-center"
                  style={{ border: "1px solid black", padding: "0px" }}
                >
                  <CardBody>
                    <CardTitle>QR Code:</CardTitle>
                    <img
                      src={accessCode?.image?.url}
                      style={{ maxWidth: "100px" }}
                    />
                    <Row className="mt-2">
                      <Col xs={6}>
                        <i
                          className="bx bx-sm bx-download"
                          style={{
                            cursor: "pointer",
                            padding: "3px",
                            border: "1px solid lightGray",
                          }}
                          title="Download"
                          onClick={() =>
                            downloadCodeHandler(
                              accessCode?.image?.url,
                              accessCode?.word
                            )
                          }
                        />
                      </Col>
                      <Col xs={6}>
                        <i
                          className="bx bx-sm bx-copy"
                          style={{
                            cursor: "pointer",
                            padding: "3px",
                            border: "1px solid lightGray",
                          }}
                          title="Copy QR url"
                          onClick={() =>
                            copyButtonHandler(accessCode?.image?.url)
                          }
                        />
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </CardGroup>
            </Col>
          ))}
        </Row>
      )}
    </Row>
  )
}

const selector = formValueSelector(FORM_NAMES.EXPERIENCE)

const mapStateToProps = state => ({
  vendorId: state.Login.vendorId,
  selectedEvent: state.experiences.selectedEvent,
  accessCodeField: selector(state, "permissions.accessCode"),
  userId: state.Login.authUser.id,
  accessCodes: state.experiences.accessCodes,
})

const mapDispatchToProps = dispatch => ({
  addAccessCode: (postImageParams, eventId) =>
    dispatch(addAccessCode(postImageParams, eventId)),
  resetSection: (form, section) => dispatch(resetSection(form, section)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddUsersByAccessCode)
